<template>
    <div class="faq-section">
        <div class="container">
            <!-- Header -->
            <div class="faq-header">
                <h3 class="faq-label">(FAQ)</h3>
                <h1 class="faq-title">Frequently Asked Questions</h1>
                <p class="faq-subtitle">Navigate with Confidence through our Frequently Asked Questions!</p>
                <div class="title-underline"></div>
            </div>

            <!-- FAQ Categories -->
            <div class="faq-content">
                <div v-for="(category, categoryIndex) in faqData" :key="categoryIndex" class="faq-category">
                    <h2 class="category-title">{{ category.categoryName }}</h2>

                    <div class="faq-list">
                        <div v-for="(item, itemIndex) in category.questions" :key="itemIndex" class="faq-item"
                            :class="{ 'is-open': openItems[`${categoryIndex}-${itemIndex}`] }">
                            <button class="faq-question" @click="toggleItem(categoryIndex, itemIndex)">
                                <span class="question-icon">
                                    <span v-if="!openItems[`${categoryIndex}-${itemIndex}`]">+</span>
                                    <span v-else>−</span>
                                </span>
                                <span class="question-text">{{ item.question }}</span>
                            </button>

                            <transition name="fade-slide" @enter="enter" @after-enter="afterEnter" @leave="leave">
                                <div v-show="openItems[`${categoryIndex}-${itemIndex}`]" class="faq-answer">
                                    <div class="answer-content" v-html="item.answer"></div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FAQSection',
    data() {
        return {
            openItems: {},
            faqData: [
                {
                    categoryName: 'About Socrates Legacy',
                    questions: [
                        {
                            question: 'What is Socrates Legacy?',
                            answer: `Socrates is a <strong>financial service broker specializing in the fields of forex and asset management</strong>. With a focus on providing expert guidance and tailored solutions, we cater to the diverse needs of our clients in the dynamic world of foreign exchange and asset investment. Also combination of individuals with reliable trading skills, experienced business people, and experts who produce sophisticated technology, to make it easier for you to profit from Forex trading.`
                        },
                        {
                            question: 'How do you execute my trade ?',
                            answer: `When you trade with us, you are trading with <strong>Socrates legacy as principle, this is the case with all Forex and CFD providers globally</strong>. We do not operate a proprietary trading book, we source our prices from external unrelated liquidity providers or directly, these prices are then passed onto you with <strong>no dealing desk</strong> intervention.`
                        },
                        {
                            question: 'Where is my money helds?',
                            answer: `Socrates Legacy holds client money in segregated client trust accounts in <strong>Tier 1 banks.</strong>`
                        },
                        {
                            question: 'Who are your Liquidity Provider ?',
                            answer: `This marks our journey in Partnership with liquidity providers:
                                    <br/><br/>May 2022: Socrates successfully partnered with its first <strong>Tier 2 Liquidity Partner, Broctagon</strong>.
                                    <br/>August 2022: Another milestone was achieved as Socrates secured its first <strong>Tier 1 Liquidity Partner, GBE Prime</strong>.
                                    <br/>March 2023: Continuing the successful trajectory, Socrates added its second <strong>Tier 1 Liquidity Partner, IS Prime</strong>.
                                    <br/><br/>The good news is that we accomplished all of this within a span of just <strong>three years</strong>.`
                        },
                        {
                            question: 'Is Socrates Legacy an ECN/STP Broker or Market Maker?',
                            answer: `This is one of the most frequently asked questions. The challenge in comprehending the meanings of <strong>ECN</strong> and <strong>STP</strong> lies in the varied interpretations by different individuals. There are three primary business models employed by Forex brokers, differing in how transactions and orders are executed: ECN, STP, and Market Makers.
                                    <br/><br/><strong>ECN (Electronic Communication Network):</strong> ECN stands for ‘Electronic Communication Network,’ a technical term describing how banks and liquidity providers connect to establish bid and offer prices. In the Forex industry, it identifies providers using this pricing mechanism to offer raw interbank pricing to retail traders. Under this model, brokers stream raw prices, and trades are either offset with another client, a liquidity provider, or held internally by the broker. This often results in faster trade execution, distinct from order execution that may involve an offsetting order placed with a liquidity provider.
                                    <br/><br/><strong>STP (Straight Through Processing):</strong> STP is short for ‘Straight Through Processing’ and is used when a Forex and CFD provider processes all trades at market prices obtained from a liquidity provider, with the price passed on by the broker. This is similar to the ECN pricing model, where the price remains unaltered, and there is no dealing desk intervention during trade processing.
                                    <br/><br/>Socrates Legacy is the issuer of the products it provides. We position ourselves as a forex provider offering the ECN pricing model by sourcing pricing from external, unrelated liquidity providers, passing these prices on to you with no dealing desk intervention. To enhance price certainty and ensure fast execution speed, we refrain from offsetting every position with our liquidity providers. We adopt this approach to deliver an improved overall trading experience.
                                    <br/><br/>To sum all of that, Socrates Legacy is <strong>NOT</strong> a market maker broker.`
                        }
                    ]
                },
                {
                    categoryName: 'Account Question',
                    questions: [
                        {
                            question: 'How to Open Account in Socrates Legacy?',
                            answer: `Here are short phrases for each step:
                                    <br/><br/>
                                    <ul>
                                        <li>Register an account with Socrates Legacy</li>
                                        <li>Log In to your dashboard</li>
                                        <li>From the dashboard, Complete the verification process (Minimum ID verification)</li>
                                        <li>The verification process will begin. Wait for your account to be verified</li>
                                        <li>After your account is verified, you will receive an email containing your account details, including your MetaTrader name, ID, Master Password and Investor Password</li>
                                        <li>Use the information to log in on the MT5 Platform.</li>
                                    </ul>`
                        },
                        {
                            question: 'Which countries are able to access your services?',
                            answer: `Socrates Legacy, as a financial service provider, restricts its services to residents of certain countries due to differing local laws and regulations. These are Afghanistan, Belarus, Botswana, Brazil, Burundi, Colombia, Congo, Cuba, Egypt, Guinea, Guinea-Bissau, Iran, Iraq, Israel, Japan, Lebanon, Liberia, Libyan Arab Jamahiriya, Mali, Myanmar, New Zealand, Nicaragua, Nigeria, North Korea, Pakistan, Somalia, Somali Republic, South Africa, Spain, Sudan, Syria, Togo, Ukraine, United States of America (including its territories), Venezuela, Yemen, and Zimbabwe. Additionally, the information on the company’s website is not targeted towards residents of U.S., Israel, New Zealand, Iran, and North Korea, officially known as the Democratic People’s Republic of Korea, or use by any person in any country where it would be illegal.`
                        },

                    ]
                },
                {
                    categoryName: 'Deposits & Withdrawals',
                    questions: [
                        {
                            question: 'What is your Deposit & Withdrawal Method?',
                            answer: `Withdrawals and deposits with our platform are characterized by speed and immediacy, facilitating seamless transactions through a variety of channels, including both local and international banking institutions, as well as cryptocurrency methods.`
                        },
                        {
                            question: 'How much is your minimum Deposit?',
                            answer: `The minimum deposit required for each account type varies. For our Philosopher Account & Stoic Account, the minimum deposit  is 100$. For Our PAMM.Account, the minimum deposit is 500 $.`
                        },
                        {
                            question: 'How Much is your minimum Withdrawal?',
                            answer: `The minimum Withdrawal in Socrates Legacy is 10 $.`
                        }
                    ]
                },
                {
                    categoryName: 'Trading Question',
                    questions: [
                        {
                            question: 'How much are your commissions?',
                            answer: `We are pleased to offer commission-free trading for our Philosopher Account. For our Stoic is 3,5$ Per lot per side. And for our PAMM. Account is 5$ Per lot per side.`
                        },
                        {
                            question: 'What is the maximum leverage on products?',
                            answer: `The maximum leverage that we offer is 1:500 And this applies to all types of accounts.`
                        },
                        {
                            question: 'What is the maximum lot size I can trade with you?',
                            answer: `We are pleased to offer Micro Lot Trading (0.01).`
                        },
                        {
                            question: 'What is a Stop Loss and Take Profit?',
                            answer: `A Stop-loss is a trade order to sell a currency when the price reaches or falls below the specified price. This is used to limit loss, usually when the trader cannot actively monitor the price. A take profit (TP) is an order that you tell or send to your broker, informing them to close your position or trade when the price reaches a specified price level in profit.`
                        },
                        {
                            question: 'Is the Demo account accurate?',
                            answer: `Yes, Our Demo account is reflected from Stoic Account. You can try the same Feature.`
                        }
                    ]
                },
                {
                    categoryName: 'Platform Question',
                    questions: [
                        {
                            question: 'What your Platform Service?',
                            answer: `<strong>We Use MetaTrader 5 (MT5)</strong>
                                    <br/><br/>MetaTrader 5 (MT5) for its advanced charting tools, support for multiple asset classes, algorithmic trading capabilities, comprehensive technical indicators, user-friendly interface, and risk management features. The platform’s versatility and accessibility make it a popular choice for both novice and experienced traders.`
                        },
                        {
                            question: 'How do I install MT5 for Windows?',
                            answer: `Yes, you can enter trades and exit them as quickly as you would like with no restrictions on-hold time or where you set your stop loss or take profit.`
                        },
                        {
                            question: 'How do I install MT5 on Mobile?',
                            answer: `You can easily download MT5 for your iOS, Android, or Harmony OS mobile phone by going through the footer section and downloading MT5 according to your device type.`
                        },
                    ]

                },
                {
                    categoryName: 'General Question',
                    questions: [
                        {
                            question: 'Do you allow scalping?',
                            answer: `Yes, you can enter trades and exit them as quickly as you would like with no restrictions on-hold time or where you set your stop loss or take profit.`
                        },
                        {
                            question: 'What is Balance, equity, margin, free margin, and margin level mean?',
                            answer: `<strong>Balance</strong> – The value of your account before considering any current open positions.

                                    <br/><br/><strong>Equity</strong> – This would be the current value of your account if all current positions were closed.

                                    <br/><br/><strong>Margin</strong> – The amount of money you must have and maintain in your account to cover any open positions.

                                    <br/><br/><strong>Free Margin</strong> – The difference between your Equity and the Margin amount above.

                                    <br/><br/><strong>Margin Level</strong> – This is the ratio of Equity to Margin, calculated by the following formula:(Equity / Margin) x 100 = Margin Level`
                        },
                        {
                            question: 'What is a CFD?',
                            answer: `The contract for difference (CFD) is a popular form of derivative trading. CFD trading enables you to speculate on the rising or falling prices of fast-moving global financial markets (or instruments) such as shares, indices, commodities, currencies and treasuries.`
                        },
                    ]

                },
            ]
        }
    },
    methods: {
        toggleItem(categoryIndex, itemIndex) {
            const key = `${categoryIndex}-${itemIndex}`;
            const isCurrentlyOpen = this.openItems[key];

            // Tutup semua item
            this.openItems = {};

            // Buka item yang diklik jika sebelumnya tertutup
            if (!isCurrentlyOpen) {
                this.openItems = { [key]: true };
            }
        },
        enter(element) {
            element.style.height = '0';
            element.style.opacity = '0';
            // Force reflow
            element.offsetHeight;
            element.style.height = element.scrollHeight + 'px';
            element.style.opacity = '1';
        },
        afterEnter(element) {
            element.style.height = 'auto';
        },
        leave(element) {
            element.style.height = element.scrollHeight + 'px';
            // Force reflow
            element.offsetHeight;
            element.style.height = '0';
            element.style.opacity = '0';
        }
    }
}
</script>

<style scoped>
.faq-section {
    background: #f9f9f9;
    padding: 100px 0;
    position: relative;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* Header */
.faq-header {
    text-align: center;
    margin-bottom: 60px;
}

.faq-label {
    color: #666;
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 10px;
    letter-spacing: 1px;
    font-family: "Fira Sans", Sans-serif;
}

.faq-title {
    color: #1a1a1a;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 15px;
    line-height: 1.2;
    font-family: "Fira Sans", Sans-serif;

}

.faq-subtitle {
    color: #666;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 20px;
    font-family: "Fira Sans", Sans-serif;

}

.title-underline {
    width: 80px;
    height: 3px;
    background: linear-gradient(135deg, #D4AF37 0%, #aa8811 100%);
    margin: 0 auto;
}

/* FAQ Content */
.faq-content {
    max-width: 900px;
    margin: 0 auto;
}

.faq-category {
    margin-bottom: 50px;
}

.faq-category:last-child {
    margin-bottom: 0;
}

.category-title {
    color: #1a1a1a;
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 25px;
    padding-left: 5px;
    font-family: "Fira Sans", Sans-serif;

}

/* FAQ List */
.faq-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.faq-item {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.faq-item:hover {
    border-color: #D4AF37;
    box-shadow: 0 4px 15px rgba(212, 175, 55, 0.1);
}

.faq-item.is-open {
    border-color: #D4AF37;
}

/* Question Button */
.faq-question {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 15px;
    background: none;
    border: none;
    padding: 20px 25px;
    cursor: pointer;
    text-align: left;
    transition: all 0.3s ease;

}

.faq-question:hover {
    background: #f9f9f9;
}

.faq-item.is-open .faq-question {
    background: #fafafa;
}

.question-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #D4AF37 0%, #aa8811 100%);
    color: #000;
    border-radius: 4px;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    transition: all 0.3s ease;
}

.question-text {
    flex: 1;
    color: #333;
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 1.4;
    font-family: "Fira Sans", Sans-serif;

}

/* Answer */
.faq-answer {
    overflow: hidden;
    transition: height 0.3s ease, opacity 0.3s ease;
}

.answer-content {
    padding: 0 25px 25px 68px;
    color: #666;
    font-size: 1rem;
    line-height: 1.8;
}

.answer-content strong {
    color: #333;
    font-weight: 700;
}

/* Animation */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    height: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .faq-section {
        padding: 60px 0;
    }

    .faq-header {
        margin-bottom: 40px;
    }

    .faq-label {
        font-size: 1rem;
    }

    .faq-title {
        font-size: 2rem;
    }

    .faq-subtitle {
        font-size: 1rem;
    }

    .category-title {
        font-size: 1.5rem;
        margin-bottom: 20px;
    }

    .faq-category {
        margin-bottom: 40px;
    }

    .faq-question {
        padding: 18px 20px;
        gap: 12px;
    }

    .question-icon {
        width: 26px;
        height: 26px;
        font-size: 1.3rem;
    }

    .question-text {
        font-size: 1rem;
    }

    .answer-content {
        padding: 0 20px 20px 58px;
        font-size: 0.95rem;
    }
}

@media (max-width: 480px) {
    .faq-section {
        padding: 40px 0;
    }

    .faq-header {
        margin-bottom: 30px;
    }

    .faq-label {
        font-size: 0.95rem;
    }

    .faq-title {
        font-size: 1.6rem;
        margin-bottom: 12px;
    }

    .faq-subtitle {
        font-size: 0.95rem;
    }

    .title-underline {
        width: 60px;
        height: 2px;
    }

    .category-title {
        font-size: 1.3rem;
        margin-bottom: 18px;
    }

    .faq-category {
        margin-bottom: 35px;
    }

    .faq-list {
        gap: 12px;
    }

    .faq-question {
        padding: 15px 18px;
        gap: 10px;
    }

    .question-icon {
        width: 24px;
        height: 24px;
        font-size: 1.2rem;
    }

    .question-text {
        font-size: 0.95rem;
    }

    .answer-content {
        padding: 0 18px 18px 52px;
        font-size: 0.9rem;
        line-height: 1.7;
    }
}
</style>
